import { type ReactElement, cloneElement } from "react";
import type { StripePriceAttributeProps } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/FormModal/types";
import {
  CouponApplicationStatus,
  useGetCouponApplication,
} from "@circle-react/components/Paywalls/Checkout/hooks/useGetCouponApplication";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { useGetReducedPrice } from "./useGetReducedPrice";

interface ReducedPriceProps {
  children: ReactElement;
  price: StripePriceAttributeProps;
}

export const ReducedPrice = ({ children, price }: ReducedPriceProps) => {
  const { paywallCustomization, couponPreviewMutation } =
    usePaywallCheckoutContext();
  const couponApplications = useGetCouponApplication(
    Number(price.id),
    couponPreviewMutation,
  );

  const hasCoupons =
    couponApplications.status !== CouponApplicationStatus.NO_COUPON_APPLIED;

  const reducedPrice = useGetReducedPrice({
    priceId: Number(price.id),
    tempId: price.tmp_id,
    reducedPriceProperties: paywallCustomization?.reduced_price_properties,
  });

  if (!reducedPrice || !reducedPrice.enabled) {
    return cloneElement(children, {
      couponApplications,
    });
  }

  return cloneElement(children, {
    couponApplications,
    reducedPrice: hasCoupons ? undefined : reducedPrice,
  });
};
